<template>
    <section class="notenartausgabe-sv">
        <template v-if="id">
            <Table
                :fields="fields"
                :items="items"
                :isBusy="busy"
                striped
                :refresh="refresh"
                :responsive="true"
            >
                <template v-slot:head(issued)="{row: row}">
                    <span
                        v-b-tooltip.hover
                        title="Aktuell verfügbare Anzahl an Noten im Archiv"
                    >{{row.label}}</span>
                </template>

                <template v-slot:head(anzahl)="{row: row}">
                    <span
                        v-b-tooltip.hover
                        title="Grundsätzlich verfügbare Anzahl an Noten im Archiv, bereits ausgegebene eingeschlossen"
                    >{{row.label}}</span>
                </template>

                <template v-slot:issued="{row: row}">
                    <b-input
                        class="issued-input"
                        size="sm"
                        placeholder="Ausgabeanzahl"
                        v-model="row.item.issued"
                        @input="changedValues(row.item)"
                    />
                    /{{row.item.diff}}
                </template>

                <template v-slot:ausgabedatum="{row: row}">
                    <b-input
                        type="date"
                        size="sm"
                        placeholder="Ausgabedatum"
                        v-model="row.item.ausgabedatum"
                        @input="changedValues(row.item)"
                    />
                </template>

                <template v-slot:geliehen="{row: row}">
                    <template v-if="row.item.geliehen == 1">
                        <font-awesome-icon icon="check" />
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="minus" />
                    </template>
                </template>
            </Table>
        </template>
        <template v-else>
            <b-alert
                show
                variant="warning"
            >Sie müssen zuerst eine Note wählen um die unterschiedlichen Ausgaben an Stimmvertreter zu verteilen</b-alert>
        </template>
    </section>
</template> 

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";

import "./NotenartausgabeSV.scss";

const NotenverwaltungApi = ApiFactory.get("notenverwaltung");

export default {
    name: "NotenartausgabeSV",
    props: ["id", "notentyp"],
    mixins: [CommonView],
    components: {
        Table
    },
    data() {
        return {
            api: NotenverwaltungApi,
            fields: [
                { key: "description", label: "Art", sortable: true },
                { key: "issued", label: "Anzahl / aktueller Bestand" },
                { key: "anzahl", label: "Gesamtbestand", class: "text-right" },
                { key: "ausgabedatum", label: "Ausgabedatum" },
                { key: "archivnr", label: "Archiv-Nr." },
                {
                    key: "geliehen",
                    label: "geliehen",
                    sortable: true,
                    class: "text-center"
                },
                { key: "geliehen_von", label: "geliehen von", sortable: true }
            ],
            refresh: false
        };
    },
    watch: {
        id: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getNotenart(this.id);
            if (response.ok) {
                var items = response.json.collection;
                if (items) {
                    items = items.map(item => this.process(item));
                    if (this.notentyp) {
                        items = items.filter(
                            item => item.notentyp === this.notentyp
                        );
                    }
                    this.items = items;
                }
            }
            this.busy = false;
        },
        process(item) {
            item.ausgabedatum = this.$moment().format("YYYY-MM-DD");
            item.issued = null;
            return item;
        },
        changedValues(obj) {
            if (!obj.ausgabedatum) {
                obj.ausgabedatum = null;
            }
            if (!obj.issued) {
                obj.issued = null;
            }
            if (obj.issued > obj.diff) {
                obj._cellVariants = { issued: "danger" };
                this.refresh = !this.refresh;
            } else {
                obj._cellVariants = { issued: "" };
                this.refresh = !this.refresh;
            }
            this.$emit("update", obj);
        }
    }
};
</script>